import { render, staticRenderFns } from "./BaseSnackBar.vue?vue&type=template&id=1f0b81de"
import script from "./BaseSnackBar.vue?vue&type=script&lang=js"
export * from "./BaseSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports